<template>
    <div id="app">
        <router-view></router-view>

        <md-dialog ref="freedisturb" class="free_disturb" :md-close-on-esc="false" :md-click-outside-to-close="false">
  <md-dialog-title>Completar Registro</md-dialog-title>

  <md-dialog-content>Recuerde completar su Registro comprando uno de los planes de Agenda Médica ON LINE.


  </md-dialog-content>

  <md-dialog-actions>
        <md-button :href="payLink" target="_blank" class="md-raised md-size btn-primary pull-left" style="background-color: #76be33; color: #ffffff;line-height: 46px;">
                                <md-icon>shopping_cart</md-icon> Pagar en Linea
                            </md-button>
                           <!-- <md-button class="md-raised md-size btn-secondary" @click="closeFreeDisturb()">Cerrar</md-button> -->
  </md-dialog-actions>
</md-dialog>
<md-dialog ref="debtor" class="free_disturb" :md-close-on-esc="true" :md-click-outside-to-close="true">
  <md-dialog-title>Usted se encuentra atrasado en sus pagos</md-dialog-title>

  <md-dialog-content>
      Usted adeuda <b>{{financial.plan_owed}} {{ financial.is_anual ? "año(s)" : "mes(es)" }}</b>.<br>
      Si ya realizo el pago simplemente refresque la pagina.


  </md-dialog-content>

  <md-dialog-actions style="justify-content: center !important;">
        <md-button @click.native="renewPlan()" class="md-raised md-size btn-primary pull-left" style="background-color: #76be33; color: #ffffff;line-height: 46px;">
                                <md-icon>shopping_cart</md-icon> Pagar ahora
                            </md-button>
                           <!-- <md-button class="md-raised md-size btn-secondary" @click="closeFreeDisturb()">Cerrar</md-button> -->
  </md-dialog-actions>
</md-dialog>


    </div>
</template>

<script>
    export default {
        name: 'app',
        data() {
            return {
                financial: {
                    plan_owed: 0,
                    is_anual: false
                }
            }
        },
        computed: {
            payLink(){
                var link;
                try{
                    if(top.location.href){
                        link = 'https://tienda.agendaenlinea.cl/'
                    }
                }catch (e){
                    link = 'http://redsaludcajagm.cl/planes/'
                }
                return link
            }
        },
        methods: {
             renewPlan(){
                if(window.lock) return;
            window.lock = true;
            this.$http.post("https://api.agendaenlinea.cl/api/expresspayment/renew", {doctor_id: this.financial.doctor_id}).then(function(data){

                if(data.data.status == 1) {
                        var form = document.createElement("form");
                        document.body.appendChild(form);
                        form.method = "POST";
                        form.action = "https://www.flow.cl/app/kpf/pago.php";
                        var element1 = document.createElement("INPUT");
                        element1.name="parameters"
                        element1.value = data.data.flowpay;
                        element1.type = 'hidden'
                        form.appendChild(element1);
                        form.submit();
                }
                window.lock = false;
                })
            },
            openFreeDisturb() {
                if(this.$refs['freedisturb']){
                    this.$refs['freedisturb'].open();
                }
            },
            openDebtorDisturb() {
                if(this.$refs['debtor']){
                    this.$refs['debtor'].open();
                }
            },
            closeFreeDisturb() {
                if(this.$refs['freedisturb']){
                    this.$refs['freedisturb'].close();
                }
            },
        },
        mounted(){
            console.log(221421424);
            var is_pro = 0;
            var old_token = "qhdh4kja";
            let func = function () {
                if(old_token != this.$auth.getToken()){
                    is_pro = 0; //cambio de user
                }
                //if(is_pro == 1 ||  this.$auth.getToken() == null) return;
                old_token = this.$auth.getToken();
                this.$http.post('/doctor/plan', {}, {
                headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
            }).then(function(response){
                console.log(response, "labplap")
                    this.financial = response.data.financial;
                    console.log(this.financial)
                    if(this.financial.plan_status == 2){
                        this.openDebtorDisturb.bind(this)();
                    }
                    if(response.data.type && response.data.type == "basic"){

                        this.openFreeDisturb.bind(this)();
                        /*setTimeout(function() {
                            this.$auth.destroyToken();
                            this.$store.dispatch('clearUser');
                            this.$router.push({ path: '/' + this.$route.params.country.toLowerCase() });
                        }.bind(this), 2000);*/
                    } else {
                        is_pro = 1;
                    }

                    }.bind(this));
            }
           /* setTimeout(func.bind(this), 100);
            setInterval(func.bind(this), (1000*120)); */
        }
    }
</script>
<style src="vue-material/dist/vue-material.css"></style>
<style src="sweetalert2/dist/sweetalert2.min.css"></style>
<style lang="stylus">
/* https://github.com/vuematerial/vue-material/issues/417 */
    input[type="color"],
    input[type="date"],
    input[type="datetime"],
    input[type="datetime-local"],
    input[type="email"],
    input[type="month"],
    input[type="number"],
    input[type="password"],
    input[type="search"],
    input[type="tel"],
    input[type="text"],
    input[type="time"],
    input[type="url"],
    input[type="week"],
    select:focus,
    textarea
        font-size 16px!important
    .md-select .md-select-value
        padding-right 16px
        line-height 35px
    .md-theme-default.md-input-container .md-icon:not(.md-icon-delete):after
        background none !important
    .datepickbox
        width 100%
        >input
            width 100%
    .display-time
        width 100% !important
    .clear-btn
        top -1em !important
    .vdp-datepicker
        input
            width 100%
            margin-top 0
            border none
            border-bottom 1px solid #ccc
            font-size 16px!important
    .md-input-container.md-input-disabled input.md-input, .md-input-container.md-input-disabled input.md-input.forcedisabled, .md-input-container.md-input-disabled div.md-select.forcedisabled .md-select-value
        color #2c4760!important
    @media (max-width: 700px)
        .free_disturb .md-button
            width 100% !important
            max-width 100% !important
            float none !important
            display block !important
        .free_disturb .md-dialog-actions
            display block !important
        .free_disturb  .md-button
            margin-left 0 !important
            margin-top 10px !important
</style>
<style lang="stylus">
    @import 'assets/styles/variables/color.styl'
    @import 'assets/styles/redesign.styl'
</style>



// WEBPACK FOOTER //
// App.vue?1c0af045